module.exports = __webpack_public_path__ + "img/72_2.764cd0c4.png";